import { useState, useContext } from "react";
import "./customSelect.scss";

// context
import { QuestionnaireContext } from "../../../contexts/questionnaireContext";

// icon
import { downIcon } from "../../../constants/icons";

const CustomSelect = () => {
  const { sectionList, selectedSection, scrollToSection } =
    useContext(QuestionnaireContext);

  const [showDropdown, setShowDropdown] = useState<boolean>(false);



  return (
    <div className="customSelect">
      <div
        className="selectedInput"
        onClick={() => {
          setShowDropdown((prev) => !prev);
        }}
      >
        {selectedSection.color !== "none" && (
          <div
            className="plate"
            style={{ backgroundColor: selectedSection.color }}
          ></div>
        )}
        <div className="value">{selectedSection.label}</div>
        <div className="iconContainer">{downIcon}</div>
      </div>
      {showDropdown && (
        <div className="dropdownlist">
          {sectionList.map((option) => (
            <div
              className="listComp"
              key={option.value}
              onClick={() => {
                scrollToSection(option);
                setShowDropdown(false);
                let ele = document.getElementById(option.value);
                ele?.scrollIntoView({ behavior: "smooth" });
                
              }}
            >
              <span
                className="plate"
                style={{
                  backgroundColor: option.color,
                }}
              ></span>
              <span className="label">{option.label}</span>
              <span className="sublabel">{option.sublabel}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
